import { useFadeIn } from '@hooks/useFadeIn'
import { experience } from '@content/portfolioData'

const narrativeQuotes: Record<string, string> = {
  'can.code Labs':
    'Not just one app but an entire ecosystem, from voice-AI workflows to production CLIs to real-time streaming architecture.',
  'Huntress':
    'The technical work was solid; the environment taught me that the worst challenges aren\'t technical, they\'re political.',
  'TaxJar (acquired by Stripe)':
    'Turned a nightmare manual process into a single button click. Eliminated 100+ developer hours annually.',
  'PaymentSpring / CardFlight':
    'Where "it works on my machine" became meaningless when handling real money and PCI compliance.',
  'Prairie Hill Learning Center':
    'Meeting people where they are, breaking complex things into understandable pieces, turned out to be exactly what engineering demands.',
}

export function ExperienceSection() {
  const fade = useFadeIn()

  return (
    <section id="experience" ref={fade.ref as React.RefObject<HTMLElement>} className={`modern-section ${fade.className}`}>
      <p className="modern-section__label">Experience</p>
      <h2 className="modern-section__title">Professional journey</h2>
      <div className="modern-timeline">
        {experience.map((exp) => (
          <div key={exp.period} className="modern-timeline__item">
            <div className="modern-timeline__dot" />
            <p className="modern-timeline__period">{exp.period}</p>
            <h3 className="modern-timeline__role">{exp.role}</h3>
            <p className="modern-timeline__company">{exp.company}</p>
            <ul className="modern-timeline__highlights">
              {exp.highlights.map((h) => (
                <li key={h}>{h}</li>
              ))}
            </ul>
            {exp.caseStudy && (
              <aside className="modern-case-study" aria-label={`Case study: ${exp.caseStudy.title}`}>
                <p className="modern-case-study__label">Featured Case Study</p>
                <h4 className="modern-case-study__title">{exp.caseStudy.title}</h4>
                <p className="modern-case-study__thesis">{exp.caseStudy.thesis}</p>
                <ol className="modern-case-study__beats">
                  {exp.caseStudy.beats.map((beat) => (
                    <li key={beat.label} className="modern-case-study__beat">
                      <p className="modern-case-study__beat-label">{beat.label}</p>
                      <p className="modern-case-study__beat-detail">{beat.detail}</p>
                    </li>
                  ))}
                </ol>
                <ul className="modern-case-study__metrics">
                  {exp.caseStudy.metrics.map((m) => (
                    <li key={m} className="modern-case-study__metric">{m}</li>
                  ))}
                </ul>
              </aside>
            )}
            {narrativeQuotes[exp.company] && (
              <p className="modern-timeline__narrative">
                {narrativeQuotes[exp.company]}
              </p>
            )}
          </div>
        ))}
      </div>
    </section>
  )
}
